
export default {
  'm': {
    'sms_login': 'تسجيل الدخول عبر الرسائل القصيرة',
    'get_vercode': 'إرسال',
    'change_mobile': 'تغيير رقم الجوال',
    'log_reg_agree': 'تسجيل الدخول / التسجيل يعني الموافقة {msg_ss}',
    'old_mobile': 'رقم الجوال الأصلي',
    'new_mobile': 'رقمالجوال الجديد',
    'agency_reginfo_fill': 'امل معلومات تسجيل الوكالة',
    'audit_res': 'نتائج المراجعة',
    'agency_name': 'اسم الوكالة',
    'agency_name_input': 'الرجاء إدخال اسم الوكالة',
    'agency_name_input_note': 'ملاحظة: يوصى بأن يكون اسم الوكالة قصيرا وسهل التذكر ولا يزيد عن 30 كلمة',
    'agency_logo': 'شعار الوكالة',
    'agency_logo_unpload_note': 'يرجى تحميل شعار الوكالة واضح بتنسيق PNG / JPG / JPEG',
    'agency_contact_name': 'اتصال الوكالة',
    'user_contact_name': 'يرجى ملء اسم الشخص الذي هو على اتصال يومي بتطبيق المستخدم',
    'agency_contact_phone': 'رقم الاتصال بالوكالة',
    'agency_whatsapp': 'واتساب بتاع وكيل',
    'agency_whatsapp_contact': 'الرجاء إدخال واتساب بتاع وكيل',
    'agency_use_lang': 'اللغة التي يستخدمها وكيل',
    'agency_head_ID': 'الايدي الوكيل',
    'agency_ID_input': 'الرجاء إدخال الايدي BuzzCast بتاع وكيل لتوزيع الرواتب لاحقًا',
    'reg_country': 'دولة التسجيل',
    'inhand_ID_photo': 'الصورة مع جواز سفر في متناول اليد',
    'upload_note_t': 'ملاحظة للتحميل',
    'agency_self_inhand_ID': 'يجب على الوكيل الصورة مع جواز سفر في متناول اليد',
    'photo_must_clearly': 'يجب أن يُظهر الجانب الأمامي بوضوح معلومات الشخص وجواز السفر الحقيقي',
    'mian_form_country': 'بلد المصدر الرئيسي للمذيعة',
    'invite_code': 'شفرة الدعوة',
    'your_profile_submit_success': 'تم تقديم المستند الخاص بك بنجاح! سنتعامل معها في أقرب وقت ممكن<br>سيتم إرسال نتائج التدقيق إلى إشعار BuzzCast APP الخاص بزعيم الجماعة ، ويرجى الانتباه للتحقق!',
    'your_profile_approved': 'رفض على المعلومات التي قدمتها سبب الرفض "الصورة مع جواز سفر في متناول اليد غير واضحة"<br>يرجى إعادة الملء أو الاتصال بالمساعد الرسمي على BuzzCast',
    'return_refill': 'العودة لإعادة الملء',
    'success_agency': 'تهانينا لدخولك بنجاح إلي التطبيق [انقر فوقي] لبدء العمل!',
    'personal_account': 'حساب شخصي',
    'my_agency': 'وكالتي',
    'your_agency_been_forcibly': 'لم يعد من الممكن إجبار وكالتك على إعادة التشغيل من خلال النظام الأساسي وسوف تقوم بتسجيل الدخول إلى النظام .إذا كانت لديك أي أسئلة فيرجى الاتصال بالمساعد الرسمي لـ BuzzCast أو العملية الخاصة',
    'invite_live_join': 'رابط لدعوة المذيعات للانضمام إلى الوكالة',
    'base_info': 'معلومات اساسية',
    'apply_time': 'وقت التطبيق',
    'join_time': 'انضم إلى الوقت',
    'cooper_status': 'حالة التعاون',
    'streamer_manage': 'إدارة المضيف',
    'sereamer_apply': 'موافق المضيف',
    'sereamer_nickname': 'اسم المضيف',
    'remark': 'ملاحظة',
    'no_remark': 'لم يكن هناك ملاحظات',
    'add_remark': 'أضف ملاحظات',
    'birth': 'تاريخ الولادة',
    'user_status': 'حالة المستخدم',
    'temporarily_frozen': 'تجميد مؤقت',
    'permanently_frozen': 'تجمد إلى الأبد',
    'fans_num': 'عدد المعجبين',
    'sign_status': 'حالة التعاقد',
    'sign_ing': 'التعاقد',
    'sign_time': 'وقت العقد',
    'release_time': 'وقت الإنهاء',
    'live_viola_record': 'تسجيلات مخالفات البث اللايف',
    'sign_record': 'سجل العقد',
    'current_contract_status': 'حالة العقد الحالي',
    'termination_reason': 'سبب الإنهاء',
    'violation_reason': 'سبب الانتهاك',
    'violation_time': 'وقت الانتهاك',
    'processing_result': 'نتيجة العملية',
    'exported_data': 'بيانات التصدير',
    'join_agency_apply': 'الموافقة على الوكالة',
    'audit_status': 'حالة القبول',
    'pending_review': 'في انتظار المراجعة',
    'pending_HQ_review': 'في انتظار مراجعة المقر',
    'not_approved_HQ': 'فشل مراجعة المقر الرئيسي',
    'withdrawn': 'فسخ',
    'audit_trail': 'سجل المراجعة',
    'oper': 'عملية',
    'other_video_materials': 'مواد فيديو أخرى',
    'pass': 'نجاح',
    'pass_streamer_join_agency_apply': 'موافق لمضيف علي انضمام الوكالة',
    'reject_streamer_join_agency_apply': 'رفض لمضيف علي انضمام الوكالة',
    'agree_streamer_join_agency': 'موافق لمضيف {msg_ss1} علي انضمام {msg_ss2} الوكالة',
    'reject_streamer_join_agency': 'رفض لمضيف {msg_ss1} علي انضمام {msg_ss2} الوكالة',
    'img_material': 'مادة الصورة',
    'approver': 'الموافق',
    'user_enter_bind_phone': 'تفضل بإدخال رقم الهاتف',
    'vericode': 'رمز التحقق',
    'input_vericode': 'الرجاء إدخال رمز التحقق',
    'login': 'تسجيل الدخول',
    'reg': 'تسجيل',
    'logout': 'الخروج من تسجيل الدخول',
    'search_for': 'بحث',
    'subscription_closed': 'ثم الغاء العقد',
    'agency_ID': 'كود النقابة： {msg_ss}',
    'reset': 'إعادة التعيين',
    'live_ID': 'معرف غرفة البث المباشر',
    'live_record': 'تسجيل شاشة الفيديو',
    'email': 'عنوان البريد الالكتروني',
    'phone': 'رقم الموبايل',
    'mastery_lang': 'إتقان اللغة',
    'to': 'إلى',
    'cancel': 'إلغاء',
    'Confirm': 'أكيد',
    'preview': 'معاينة',
    'rejected': 'مرفوض',
    'tip': 'التنبيه',
    'i_got_it': 'حصلت عليه',
    'cancelled': 'تم تسجيل الخروج',
    'refused': 'رفض',
    'agency_agree': 'وافقت الوكالة',
    'platform_agree': 'وافقت المنصة',
    'user_not_exist': 'هذا المستخدم غير موجود',
    'user_frozen': 'تم تجميد المستخدم',
    'reviewing': 'قيد الاستعراض',
    'review_pass': 'المراجعة التي تم تمريرها',
    'review_failed': 'فشل التدقيق',
    'xx_hours': '{msg_ss} ساعة',
    'xx_days': '{msg_ss} يوم',
    'xx_hour': '{msg_ss} ساعة',
    'xx_day': '{msg_ss} يوم',
    'xx_year': '{msg_ss} سنة',
    'xx_years': '{msg_ss} سنين',
    'check_phone_istrue': 'يرجى التحقق مما إذا تم إدخال رقم الهاتف بشكل صحيح',
    'male': 'ذكر',
    'female': 'انثى',
    'avatar': 'صورة',
    'normal': 'عادي',
    'live_room': 'غرفة البث',
    'view': 'عرض',
    'oper_success': 'العملية الناجحة',
    'copy_success': 'نسخة ناجحة',
    'new_mobile_already_reg': 'تم تسجيل رقم الجوال الجديد',
    'general_user': 'مستخدم عادي',

    'copy': 'نسخة',
    'gender': 'جنس',
    'submit': 'تقديم',
    'permanent': 'الدائم',
    'agree_agreement': 'الموافقة والالتزام بالعقد',
    'vericode_error': 'رمز التحقق غير صحيح',
    'resend': 'أرسل مرة أخري',
    'approved': 'تم الاجتياز بنجاح',
    'not_approved': 'لم ينجح',
    'agency_rejected': 'تم الرفض من المنصة',
    'select': 'اختيار',
    'search': 'بحث',
    'rejection_reason': 'سبب الرفض',
    'no_data': 'البيانات فارغة',
    'oper_failed': 'فشلت العملية',
    'leave_agency_apply': 'الموافقة على الانسحاب',
    'over_word_limit': 'تم تجاوز حد الكلمات',
    'delete': 'حذف',
    'nickname': 'كنية',
    'file_is_too_large': 'ملف كبير جدًا',



    'community_convention': 'اتفاقية مجتمع بازكاست',
    'approval_time': 'وقت المعالجة',
    'guild_system_title': 'نظام نقابة منصة اجتماعية BuzzCast',
    'return': 'إرجاع',
    'img_upload_fail': 'فشل رفع الصورة',
    'cooper_ing': 'في تعاون',
    'upload_file_format_incorrect': 'الملف الذي تم تحميله ليس بالتنسيق الصحيح',
    'token_invalid': 'الرمز غير صالح ، الرجاء تسجيل الدخول مرة أخرى!',
    'network_busy': 'الشبكة مشغولة ، حاول اعادة',
    'minute': '{msg_ss}دقيقة',

    'live_room_ID': 'غرفة البث المباشر ID',

    'scan_code': 'مسح رمز BuzzCast APP لتسجيل الدخول',
    'open_code': 'افتح BuzzCastApp ، انقر فوق رمز الاستجابة السريعة الخاص بي للمسح الضوئي',
    'refresh': 'تحديث',
    'login_confirm': 'تأكيد تسجيل الدخول',
    'account': 'معلومات الحساب',
    'user_name': 'اسم االمستخدم',
    'edit': 'تعديل',
    'changing': 'تغيير ملزم',
    'mobile_number': 'حساب الهاتف المحمول',
    'mobile_login': 'يمكنك تسجيل الدخول باستخدام رقم هاتفك المحمول {msg_ss}',
    'appId_login': 'يمكنك استخدام الحساب الذي يكون معرف التطبيق الخاص به [{msg_ss}] للمسح الضوئي وتسجيل الدخول',
    'code_login': 'BuzzCastAppID غير ملزم ، بعد الربط ، يمكنك استخدام رمز الاستجابة السريعة لمسح الرمز لتسجيل الدخول',
    'verification_log': 'رقم الهاتف المحمول غير ملزم ، بعد الربط ، يمكنك استخدام رقم الهاتف المحمول ورمز التحقق لتسجيل الدخول',
    'binding_success': 'نجح الربط',
    'binding_mobile': 'ربط رقم الهاتف المحمول',
    'edit_name': 'تعديل اسم المستخدم',
    'binding_alert': 'نصائح لتغيير الإلزام',
    'new_appId': 'استخدم مباشرة ربط كود مسح APPID الجديد ، سيتم استبدال معرف التطبيق الأصلي مباشرة',
    'binding_account': 'ربط حساب BuzzCastApp',
    'anchor_earings': 'دخل المرساة',
    'signing_date': 'تاريخ العقد',
    'statistical_date': 'تاريخ الإحصاء',
    'valid_min': 'إجمالي الوقت الفعلي (بالدقائق)',
    'valid_day': 'أيام صالحة (أيام)',
    'total_revenue': 'إجمالي الإيرادات',

    'bind': 'ربط',
    'please_agree_agree': 'الرجاء الموافقة على الاتفاقية',
    'note': 'ملاحظة: الوقت الذي يعرضه هذا النظام هو توقيت نيويورك (EST)',
    'app_phone': 'تسجيل رقم الهاتف المحمول APP',
    'host_num': 'عدد المضيف',
    'enter_host_num': 'الرجاء إدخال رقمه لجميع المضيفين',
    'platform': 'منصة تعاون',
    'statement': 'كشف حساب بنكي شهري',
    'enter_income': 'الرجاء إدخال متوسط الدخل الشهري',
    'check_commas': 'تنسيق غير صحيح. يرجى التحقق مما إذا كانت الأنظمة الأساسية المتعددة مفصولة بفواصل',
    'submit_success': 'تم تقديم المستند الخاص بك بنجاح! سنتعامل معها في أقرب وقت ممكن',
    'usd': 'دولار',
    'many_platforms': 'يرجى الدخول إلى منصة البث المباشر التي تعاونت معها من قبل ، حتى 20 منصة',
    'limit_platform': 'ما يصل إلى 20 منصة',
    'user_has_delete': 'هذا المستخدم تم تسجيل الخروج',
    'cant_commit': 'أنت مذيع متعاقد بالفعل ، ولا يمكنك التقدم بطلب للحصول على نقابة لتستقر فيها في نفس الوقت',
    'cant_commit_1': 'لقد تقدمت بالفعل إلى مذيع متعاقد ، ولا يمكنك التقدم بطلب للحصول على نقابة لتستقر فيها في نفس الوقت',
    'passwd': 'كلمة المرور',
    'passwd_placeholder': 'يجب أن تحتوي كلمة مرورك على 6 إلى 20 حرفًا',
    'live_rights': 'تقييم بدون وقت',
    'edit_log': 'غير التسجيل',
    'edit_time': 'غير الوقت',
    'edit_pwd': 'تغيير كلمة المرور',
    'old_pwd': 'كلمة المرور القديمة',
    'new_pwd': 'كلمة المرور الجديدة',
    'confirm_pwd': 'تأكيد كلمة المرور',
    'forget_pwd': 'هل نسيت كلمة مرورك؟',
    'email_check': 'تنسيق البريد الإلكتروني غير صحيح ',
    'phone_pwd_error': 'رقم الهاتف أو كلمة المرور غير صحيحة',
    'ten_min_error': 'يرجى المحاولة مرة أخرى بعد 10 دقائق',
    'phone_bind_error': 'تم ربط رقم الهاتف المحمول بحساب آخر ، يرجى التغيير إلى رقم هاتف محمول جديد للربط.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'تم بالفعل ملء ID زعيم الجماعة ، يرجى إعادة تعبئته',
    'pwd_error': 'كلمة سر خاطئة ',
    'phone_not_reg_error': 'الحساب غير مسجل',
    'pwd_nq': 'كلمات المرور الجديدة التي تم إدخالها غير متناسقة ',
    'sign_anchor_error': 'أنت مذيع متعاقد بالفعل ، ولا يمكنك التقدم بطلب للحصول على نقابة لتستقر فيها في نفس الوقت',
    'apply_anchor_error': 'لقد تقدمت بالفعل إلى مذيع متعاقد ، ولا يمكنك التقدم بطلب للحصول على نقابة لتستقر فيها في نفس الوقت',
    'have-expired': 'منتهي الصلاحية ',
    'approval-time': 'وقت المعالجة',
    'reasons-for-refusal': 'الرجاء إدخال سبب الرفض',
    'Transfer-grounds': 'تعليمات النقل',
    'code_expire': 'انتهت صلاحية رمز التحقق ، يرجى النقر فوق رمز التحقق للتحديث',
    'transfer-approval': ' الموافقة على التحويل',
    'live_state_placeholder': 'حالة البث',
    'live_state_open': 'طبيعي',
    'live_state_temporary_banned': 'محظور',
    'live_state_forever_banned': 'فرض حظر دائم',
    'live_allowed_time': 'وقت البدء المسموح به',
    'live_banned_time': 'فترة المنع',
    'deduct_money': 'خصم كمية من العملات B',
    'final_income': 'دخل حقيقي',
    'select_start_dt': 'الرجاء تحديد وقت البدء',
    'select_end_dt': 'الرجاء تحديد وقت الانتهاء',
    'less_then_end_dt': 'يجب أن يكون وقت البدء أقل من أو يساوي وقت الانتهاء',
    'System_automatically_through': 'النظام يمر تلقائيا',
    'btrade_err': 'معرف الوكالة غير متوفر',

    'mouth_anchor': 'مرساة الراتب الشهري',
    'day_anchor': 'مرساة الراتب اليومي',
    'guild_anchor': 'مكافأة قائد النقابة (الراتب اليومي)',
    'mouth_anchor_st': 'وقت بدء الراتب الشهري',
    'mouth_anchor_et': 'وقت انتهاء الراتب الشهري',
    'day_anchor_st': 'وقت بدء الراتب اليومي',
    'day_anchor_et': 'وقت انتهاء الراتب اليومي',
    'all_award_bcoin': 'مكافأة الراتب اليومي إجمالي الدخل',
    'live_hour': 'البث المباشر مكافأة مدة صالحة',
    'salary_day': 'تاريخ',
    'day_in_come': 'دخل النقابة لهذا اليوم (عملات B)',
    'award_ration_flag_str': 'نسبة المكافأة',
    'payable_money': 'مكافأة عملة زعيم النقابة B',
    'host_bcoins': 'عملات B التي تلقاها المضيف',
    'total_official': 'إجمالي عملات B من المكافأة الرسمية',
    'actual_bcoins_awarded': 'عملات B المكافأة الفعلية',
    "change_bound_account":"تغيير الحساب المربوط" ,
    "agent_id_form":"ID مدير الوكالة:" ,
    "BuzzCast_verification_code":"رمز التحقق BuzzCast:" ,
    "send_success":"إرسال النجاح" ,
    "account_changed_successfully":"تم تغيير الحساب المربوط بنجاح." ,
    "invite_guild_url":"رابط دعوة لتصبح رئيس الوكالة: {msg_ss}" ,
    "invite_guild_code":"رمز الدعوة الخاص بي: {msg_ss}" ,
    "save":"حفظ" ,
    "compile":"تحرير" ,
    "agent_nvitation_eward":"مكافأة دعوة مدير الوكالة" ,
    "agent_name":"لقب زعيم الوكيل" ,
    "guild_id":"رمز الوكالة" ,
    "guild_income_30days":"دخل الوكيلة لآخر 30 يومًا" ,
    "guild_invite_income_30days":"الدخل لدعوة الوكالات خلال الثلاثين يومًا الماضية" ,
    "agency_commission_ratio":"نسبة عمولة الوكالة" ,
    "invite_income_bcoins":"مكافآت الدعوة عملات B" ,
    "id_not_exist":"IDغير موجود" ,
    "reward_distribution_status": "حالة توزيع المكافأة",
    'must_number': 'يجب أن تكون مدخلاتك بتنسيق رقمي بحت.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ar.js